import BaseApi from "../base/BaseApi";

class KeytchensApi extends BaseApi {
  private _isDev: boolean;

  constructor(isDev: boolean = false, isPopina: boolean = true) {
    super(
      isDev
        ? isPopina
          ? "https://us-central1-popina-dev.cloudfunctions.net/api/v1/keytchens"
          : "https://us-central1-jalia-dev.cloudfunctions.net/api/v1/keytchens"
        : isPopina
        ? "https://us-central1-popina-prod.cloudfunctions.net/api/v1/keytchens"
        : "https://us-central1-jalia-prod.cloudfunctions.net/api/v1/keytchens",
      false
    );
    this._isDev = isDev;
  }

  public get isDev(): boolean {
    return this._isDev;
  }

  private get header(): any {
    return {
      "Content-type": "Application/json",
      crossDomain: "true",
      Authorization: "Bearer lzPoPoiZ19OplVETRyzWyK9T5fNDiPl9"
    };
  }

  loadService = (uid: string) => {
    return this.getRequest(`/${uid}`, this.header);
  };

  connectService = (companyUuid: string, uid: string) => {
    return this.postRequest(`/connect`, this.header, {
      companyUuid,
      uid
    });
  };

  disconnectService = (uid: string) => {
    return this.postRequest("/disconnect", this.header, { uid });
  };
}

export default KeytchensApi;
